import React from 'react';
import { createCn } from '../../../helpers/utils';
import classes from '../styles.module.scss';
import { FlaskIcon, MusicIcon, WaveformIcon } from '../../../assets';
import { FileVisualType } from '../../files/utils/file-type';

const cn = createCn('overview', classes);

interface IProps {
  type: FileVisualType;
}

const FileTypeIcon: React.FC<IProps> = ({ type }) => {
  const icons: Record<FileVisualType, React.ReactNode> = {
    audio: <MusicIcon />,
    diarization: <WaveformIcon />,
    test: <FlaskIcon />,
    zoom: <MusicIcon />,
  };

  return (
    <div className={cn('file-icon', { [type]: true })}>
      {icons[type]}
    </div>
  );
};

export default FileTypeIcon;
